<div class="university-card">
  <!-- Logo -->
  <div class="logo">
    <p-avatar
      *ngIf="!imageError && photoUrl; else defaultAvatar"
      [image]="$any(photoUrl)"
      shape="circle"
      size="large"
      (onImageError)="imageError = true"
    />
    <ng-template #defaultAvatar>
      <p-avatar
        [label]="getInitials(candidato?.profissional?.nome)"
        [icon]="!candidato?.profissional?.nome ? 'pi pi-user' : undefined"
        shape="circle"
        size="large"
      />
    </ng-template>
  </div>

  <!-- Name and Description -->
  <div class="details">
    <div style="display: flex; align-items: center; gap: 0.5rem;">
      <h3 class="name" style="margin-bottom: 0;">{{ candidato?.profissional?.nome || 'Candidato Desconhecido' }}</h3>
      <span *ngIf="candidato?.codigo" class="cand-code-badge" style="font-family: monospace; font-size: 0.75rem; font-weight: 600; padding: 0.15rem 0.4rem; border-radius: 4px; background: #e0f2fe; color: #0369a1;">{{ candidato.codigo }}</span>
    </div>
    <div class="contact-info">
      <div class="info-item">
        <span>{{ candidato?.profissional?.especialidadesFuncoes ||
          designacaoFuncao || 'Função Desconhecida' }} </span>
      </div>
    </div>
  </div>

  <div class="extra-info">

    <div class="container-estado" *ngIf="candidato?.removerCandidatura">
      <p-tag value="Removida" severity="danger" [title]="candidato?.motivoRemoverCandidatura || 'Candidatura removida'"></p-tag>
    </div>

    <div class="container-estado">
      <p-tag [value]="candidato?.estadoCandidatura" [severity]="getSeverity(candidato?.estadoCandidatura)"></p-tag>
    </div>

    <div class="info-item">

      <p-tag [severity]="'info'">
        <span class="info">{{ candidato?.profissional?.nivelHabilitacao || 'Sem Habilitação'}}</span>
      </p-tag>
    </div>

    <div class="info-item">
      <div class="icon">
        <img src="icons/phone.svg" alt="Ícone de phone" />
      </div>
      <span class="info">{{ candidato?.profissional?.telefonePrincipal || 'Sem telemóvel' }}</span>
    </div>

    <div class="info-item">
      <div class="icon">
        <img src="icons/calendar.svg" alt="Ícone de clock" />
      </div>
      <span> {{ candidato?.dataCandidatura}}</span>
    </div>
  </div>

  <!-- Navigation Icon -->
  <div class="navigate">
    <p-button severity="secondary" (onClick)="actionClick(candidato)" icon="pi pi-angle-right"></p-button>
    <!--<img src="icons/arrow-right.svg" alt="Navigate Icon"  /> -->
  </div>
</div>

<p-drawer [(visible)]="showDetalhe" position="right" [style]="{'width': '720px'}"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-template #headless>
    @if (maisDetalheProfissional) {
    <app-candidatura-detalhe [candidatura]="candidato" (onCloseModal)="showDetalhe=false"
      [vagaDetail]="vaga"></app-candidatura-detalhe>

    <!-- <app-perfil-profissional [perfilSelected]="maisDetalheProfissional" (onCloseModal)="closeDrawer()"></app-perfil-profissional> -->
    }
  </ng-template>
</p-drawer>